<template>
  <transition name = "fade">
  <div class="loading-wrap" v-show="showLoading">
    <div class="loading">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      showLoading: false
    }
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.fade-leave-active {
  transition: all 1.5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.loading-wrap{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: #fff;
 background:rgba(0, 0, 0, .5);
}
.loading {
  width: 250px;
  height: 30px;
}
.loading span {
  display: inline-block;
  width: 30px;
  height: 100%;
  margin-right: 10px;
  background: #ce2a06;
  -webkit-transform-origin: right bottom;
  -webkit-animation: load 1s ease infinite;
}
.loading span:last-child {
  margin-right: 0px;
}
@-webkit-keyframes load {
  0% {
    opacity: 1;
    -webkit-transform: scale(1);
  }
  100% {
    opacity: 0;
    -webkit-transform: rotate(90deg) scale(0.3);
  }
}
.loading span:nth-child(1) {
  -webkit-animation-delay: 0.13s;
}
.loading span:nth-child(2) {
  -webkit-animation-delay: 0.26s;
}
.loading span:nth-child(3) {
  -webkit-animation-delay: 0.39s;
}
.loading span:nth-child(4) {
  -webkit-animation-delay: 0.52s;
}
.loading span:nth-child(5) {
  -webkit-animation-delay: 0.65s;
}
</style>
